'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inspectControl = inspectControl;

var _reduxShip = require('redux-ship');

function inspectControl(control) {
  return regeneratorRuntime.mark(function _callee(action) {
    var _ref, snapshot;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.delegateYield((0, _reduxShip.snap)(control(action)), 't0', 1);

          case 1:
            _ref = _context.t0;
            snapshot = _ref.snapshot;

            window.postMessage({
              type: 'ReduxShipDevtools',
              payload: {
                action: action,
                snapshot: snapshot
              },
              version: 1
            }, '*');

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-ship-devtools/dist/main/index.js
 ** module id = 527
 ** module chunks = 0
 **/